import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || "/dashboard";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name.split(" ")[0]}!`);
      navigate(u.role === "admin" ? "/admin" : from);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-nx flex min-h-[80vh] items-center justify-center py-12">
      <div className="w-full max-w-md">
        <div className="card-nx p-8 animate-fade-up">
          <div className="flex justify-center"><Logo /></div>
          <h1 className="mt-6 text-center text-2xl font-bold text-[#0B192C] font-head">Welcome back</h1>
          <p className="mt-2 text-center text-sm text-slate-500">Sign in to your Vishwakarma Nexus account</p>

          <form onSubmit={submit} className="mt-7 space-y-4" data-testid="login-form">
            <div>
              <label className="mb-1.5 block text-sm font-medium text-[#0B192C]">Email</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="input-nx" placeholder="you@example.com" data-testid="login-email-input" />
            </div>
            <div>
              <div className="mb-1.5 flex items-center justify-between">
                <label className="text-sm font-medium text-[#0B192C]">Password</label>
                <Link to="/forgot-password" className="text-xs font-medium text-[#B8860B] hover:underline" data-testid="login-forgot-link">
                  Forgot password?
                </Link>
              </div>
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="input-nx" placeholder="••••••••" data-testid="login-password-input" />
            </div>
            {error && <p className="text-sm text-red-600" data-testid="login-error">{error}</p>}
            <button type="submit" disabled={loading} className="btn-gold w-full" data-testid="login-submit-btn">
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>

          <p className="mt-6 text-center text-sm text-slate-500">
            New to the community?{" "}
            <Link to="/register" className="font-semibold text-[#0B192C] hover:underline" data-testid="login-to-register">
              Join Now
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
